export const formatCurrency = (value: number) =>
  new Intl.NumberFormat('zh-CN', {
    style: 'currency',
    currency: 'CNY',
    maximumFractionDigits: 0,
  }).format(value || 0);

export const formatCompactCurrency = (value: number) => {
  const absolute = Math.abs(value);
  if (absolute >= 100_000_000) return `¥${(value / 100_000_000).toFixed(2)}亿`;
  if (absolute >= 10_000) return `¥${(value / 10_000).toFixed(1)}万`;
  return formatCurrency(value);
};

export const formatNumber = (value: number, maximumFractionDigits = 0) =>
  new Intl.NumberFormat('zh-CN', { maximumFractionDigits }).format(value || 0);

export const formatPercent = (value: number, digits = 1) => `${Number.isFinite(value) ? value.toFixed(digits) : '0.0'}%`;

export const formatDate = (value: string) => {
  if (!value) return '—';
  const [year, month, day] = value.split('-');
  return `${year}.${month}.${day}`;
};

export const formatDateTime = (value: string) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('zh-CN', {
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(date);
};

export const percentChange = (current: number, prior: number | null) => {
  if (prior === null || prior === 0) return null;
  return ((current - prior) / Math.abs(prior)) * 100;
};

export const sanitizeFileName = (value: string) => value.replace(/[\\/:*?"<>|]/g, '-');
